export const SupplierOffer = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0357 1.5V6.07143C14.0357 6.37454 14.1561 6.66523 14.3705 6.87955C14.5848 7.09388 14.8755 7.21429 15.1786 7.21429H19.75"
        stroke="#99A0AE"
        strokeWidth="1.52381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4643 22.0714H6.03572C5.42951 22.0714 4.84813 21.8306 4.41947 21.402C3.99082 20.9733 3.75 20.3919 3.75 19.7857V3.78572C3.75 3.17951 3.99082 2.59813 4.41947 2.16947C4.84813 1.74082 5.42951 1.5 6.03572 1.5H14.0357L19.75 7.21429V19.7857C19.75 20.3919 19.5092 20.9733 19.0805 21.402C18.6519 21.8306 18.0705 22.0714 17.4643 22.0714Z"
        stroke="#99A0AE"
        strokeWidth="1.52381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0357 10.6426H11.1786C10.7239 10.6426 10.2879 10.8232 9.96641 11.1447C9.64492 11.4662 9.46431 11.9022 9.46431 12.3569C9.46431 12.8115 9.64492 13.2476 9.96641 13.569C10.2879 13.8905 10.7239 14.0712 11.1786 14.0712H12.3215C12.7761 14.0712 13.2121 14.2518 13.5336 14.5733C13.8551 14.8947 14.0357 15.3308 14.0357 15.7854C14.0357 16.2401 13.8551 16.6761 13.5336 16.9976C13.2121 17.3191 12.7761 17.4997 12.3215 17.4997H9.46431"
        stroke="#99A0AE"
        strokeWidth="1.52381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 17.5V18.6429M11.75 9.5V10.6429"
        stroke="#99A0AE"
        strokeWidth="1.52381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
